import { EnvConfig } from "../../types";

export const communicationsConfigLocal: EnvConfig = {
  MODULE_NAME: "communications",
  MODULE_ENV: "local",
  LD_CLIENT_SIDE_ID: "63583be10d275b11a1f32f7b",
  MANIFEST_URL: "http://localhost:4200/module-federation.manifest.json",
  BASE_URL: "https://inbox-bff-api.np-communications.app.coxautoinc.com/api/",
  MEDIA_BFF_URL: "https://media-bff-api.np-communications.app.coxautoinc.com",
  MEDIA_LIBRARY_URL: "https://media-library-np.vinccrmnp.cloud"
};
